import React from 'react';

const BigGallery = () => {
    return (
        <div>
            <section className="text-gray-600 body-font">
                <div className="container px-5 py-24 mx-auto flex flex-wrap">
                    <div className="flex w-full mb-20 flex-wrap">
                        <h1 className="sm:text-3xl text-2xl font-medium title-font text-gray-900 lg:w-1/3 lg:mb-0 mb-4">If not now, When? Lets
                            work together!</h1>
                        <p className="lg:pl-6 lg:w-2/3 mx-auto leading-relaxed text-base">My passion for capturing smiles and genuine moments is insatiable, and I always strive to create a seamless and fun experience for all of my clients. It’s kinda our thing!
                            So shoot me a message and I will be in touch usually the same day! I cannot wait to meet you and hear all about your special day or idea</p>
                    </div>
                    <div className="flex flex-wrap md:-m-2 -m-1">
                        <div className="flex flex-wrap w-1/2">
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://images.unsplash.com/photo-1541595948840-f299cdb13759?auto=format&q=75&fit=crop&crop=top&w=500&h=300" />
                            </div>
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://images.unsplash.com/photo-1512316609839-ce289d3eba0a?auto=format&q=75&fit=crop&crop=top&w=501&h=301" />
                            </div>
                            <div className="md:p-2 p-1 w-full">
                                <img alt="gallery" className="w-full h-full object-cover object-center block" src="
                                https://images.unsplash.com/photo-1543556154-22e2cfecff69?auto=format&q=75&fit=crop&crop=top&w=600&h=360" />
                            </div>
                        </div>
                        <div className="flex flex-wrap w-1/2">
                            <div className="md:p-2 p-1 w-full">
                                <img alt="gallery" className="w-full h-full object-cover object-center block" src="https://images.unsplash.com/photo-1591161555818-7b9debeccc07?auto=format&q=75&fit=crop&crop=top&w=601&h=361" />
                            </div>
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="
                               https://images.unsplash.com/photo-1511288702291-e55d6cfbe3b5?iauto=format&q=75&fit=crop&crop=top&w=502&h=302" />
                            </div>
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="
                                https://images.unsplash.com/photo-1544142294-04f61a76633e?auto=format&q=75&fit=crop&crop=top&w=503&h=303" />
                            </div>
                        </div>
                    </div>
                    <br className='mt-5' />
                    <div className="flex flex-wrap md:-m-2 -m-1">
                        <div className="flex flex-wrap w-1/2">
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://images.unsplash.com/photo-1601506521937-0121a7fc2a6b?auto=format&q=75&fit=crop&crop=top&w=500&h=300" />
                            </div>
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://images.unsplash.com/photo-1558554970-1e3279cd745d?auto=format&q=75&fit=crop&crop=top&w=501&h=301" />
                            </div>
                            <div className="md:p-2 p-1 w-full">
                                <img alt="gallery" className="w-full h-full object-cover object-center block" src="
                                https://images.unsplash.com/photo-1560519622-7229023b9c86?auto=format&q=75&fit=crop&crop=top&w=600&h=360" />
                            </div>
                        </div>
                        <div className="flex flex-wrap w-1/2">
                            <div className="md:p-2 p-1 w-full">
                                <img alt="gallery" className="w-full h-full object-cover object-center block" src="https://images.unsplash.com/photo-1536593998369-f0d25ed0fb1d?auto=format&q=75&fit=crop&crop=top&w=601&h=361" />
                            </div>
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="
                               https://images.unsplash.com/photo-1517309230475-6736d926b979?auto=format&q=75&fit=crop&crop=top&w=502&h=302" />
                            </div>
                            <div className="md:p-2 p-1 w-1/2">
                                <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?iauto=format&q=75&fit=crop&crop=top&w=503&h=303" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BigGallery;